export default __webpack_public_path__ + "static/media/diamond-clarity-5@3x.9b55a287.png";